// WIth this value schema loading takes appropriate amount of time and doesn't crash the app
export const MAX_IDENTIFIERS_COUNT = 30000;
